/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import RightModalLayout from '../../../../layouts/Modal/RightModalLayout';
import SendPdfWithPaymentLinksContent from './SendPdfWithPaymentLinksContent';
import { useSendPdfWithPaymentLinks } from '../../hooks/useSendPdfWithPaymentLinks';

const SendPDFWithPaymentLinksModal = ({
  order,
  onSendPdf
}) => {
  const { t } = useTranslation('Inbox');
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch({
      type: 'CLOSE_SIDEBAR'
    });
  };

  const {
    paymentMethods,
    toggleMethod,
    handleSendPdf,
    saving,
    selectedPaymentMethods
  } = useSendPdfWithPaymentLinks({ order, onClose, onSendPdf });

  return (
    <div className="tw-wrapper">
      <RightModalLayout
        title={t('sendPaymentLinks.sendPdfTitle')}
        closeAction={onClose}
        submitAction={handleSendPdf}
        submitLabel={t('sendPaymentLinks.sendPdf')}
        loading={saving}
        disabled={!selectedPaymentMethods.length}
      >
        <SendPdfWithPaymentLinksContent
          paymentMethods={paymentMethods}
          onToggle={toggleMethod}
        />
      </RightModalLayout>
    </div>
  );
};

export default SendPDFWithPaymentLinksModal;
